import * as React from "react";
//MUI COMPONENTS
import { Switch, FormHelperText, Box, Stepper, Step, StepLabel, Button, Typography,
  TextField, Autocomplete, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
//STYLES
import styles from "../../../module_css/formsCatalogs.module.css";
import ApiController from "../../../controllers/api";
import Swal from "sweetalert2";
import CustomBackdrop from "../../CustomBackdrop";
import { ArrowForward, Done, Queue } from "@mui/icons-material";

//PICTURES
import imgAdd from "../../../assets/svg/add.svg";
const ERROR_MESSAGES = {//MENSAJES DE ERROR
  required: "EL CAMPO ES OBLIGATORIO",
  invalid: "EL VALOR DEL CAMPO NO CUMPLE CON EL FORMATO",
  minLength: "EL VALOR DEL CAMPO ES DEMASIADO CORTO",
  maxLength: "EL VALOR DEL CAMPO ES DEMASIADO LARGO",
};
const PROPERTIES_ENTRIES = {
  partida: {
    required: true,
  },
  bien: {
    required: true,
  },
  edificio: {
    required: true,
  },
  area: {
    required: true,
  },
  costo: {
    required: true,
    pattern: /^\d+(\.\d{1,3})?$/
  },
  marca: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s\.-]+$/,
    minLength: 5,
    maxLength: 80,
  },
  modelo: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s\.-]+$/,
    minLength: 5,
    maxLength: 80,
  },
  noSerie: {
    required: true,
    pattern: /^[A-Z0-9\-\.]+$/,
    minLength: 5,
    maxLength: 80,
  },
  noFactura: {
    required: true,
    pattern: /^[A-Z0-9]+$/,
    minLength: 5,
    maxLength: 80,
  },
  fechaAdquisicion: {
    required: true,
    pattern: /^(19|20)\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
  },
  noPoliza: {
    required: true,
    pattern: /^[A-Z0-9\.-]+$/,
    minLength: 5,
    maxLength: 80,
  },
  noInvAnterior: {
    required: true,
    pattern: /^[A-Z0-9\.-]+$/,
    minLength: 5,
    maxLength: 50,
  },
  proveedor: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s\.-]+$/,
    minLength: 10,
    maxLength: 100,
  },
  observaciones: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s.,;:!¿?()"'\/\-]+$/,
    minLength: 10,
    maxLength: 100,
  },
  foto: {
    required: true,
  },
  estadoFisico: {
    required: true,
  },
  descripcionFisica: {
    required: true,
    pattern: /^[A-ZÁÉÍÓÚÑ0-9\s,.\-()/]+$/,
    minLength: 10,
    maxLength: 100,
  },
};

const hoy = new Date();
const fechaHoy = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;

export default function FormCreateInventory({ handleClose, refreshArea }) {
  const steps = [//ENCABEZADOS DE STEPPER
    "SELECCIÓN PARTIDA",
    "SELECCIÔN BIEN",
    "SELECCIÓN EDIFICIO",
    "SELECCIÓN ÁREA",
    "DATOS ADICIONALES",
    "SELECCIÓN IMAGEN",
  ];
  const stepperRef = React.useRef(null);
  const stepRefs = React.useRef([]);
  const [openBackdrop, setOpenBackdrop] = React.useState(false); //* = ESTADO PARA CONTROLAR EL BACKDROP
  const [dataGet, setDataGet] = React.useState({//* - ESTADO PARA GUARDAR DATOS CONSTANTES DE LOS SELECT
    AREA: [], BUILDING: [], PARTIDA: [],
    PROPERTY: [], ESTADO_FISICO: [],
  });
  const [data, setData] = React.useState({//* - ESTADO DATOS VALUES
    partida: "", bien: "", edificio: "", area: "", costo: null,
    marca: "", modelo: "", noSerie: "", estadoFisico: null, noFactura: "",
    fechaAdquisicion: null, noPoliza: "", noInvAnterior: null, proveedor: "",
    descripcionFisica: "", observaciones: "", foto: "",
  });
  const [controllSwitch, setControllSwitch] = React.useState({
    costo: true, marca: true, modelo: true, noSerie: true, noFactura: true, fechaAdquisicion: true,
    noPoliza: true, noInvAnterior: true, proveedor: true, observaciones: true
  });

  const fields = [
    { name: "costo", label: "COSTO", description: "¿EL BIEN TIENE COSTO?", type: "number" },
    { name: "marca", label: "MARCA", description: "¿EL BIEN TIENE MARCA?", type: "text" },
    { name: "modelo", label: "MODELO", description: "¿EL BIEN TIENE MODELO?", type: "text" },
    { name: "noSerie", label: "NÚMERO DE SERIE", description: "¿EL BIEN TIENE NÚMERO DE SERIE?", type: "text" },
    { name: "noFactura", label: "NÚMERO DE FACTURA", description: "¿EXISTE UNA FACTURA ASOCIADA?", type: "text" },
    { name: "fechaAdquisicion", label: "FECHA DE ADQUISICIÓN", description: "¿EL BIEN TIENE FECHA DE ADQUISICIÓN?", type: "date" },
    { name: "noPoliza", label: "NÚMERO DE PÓLIZA", description: "¿EL BIEN TIENE NÚMERO DE PÓLIZA?", type: "text" },
    { name: "noInvAnterior", label: "NÚMERO DE INVENTARIO ANTERIOR", description: "¿EXISTE UN NÚMERO DE INVENTARIO ANTERIOR?", type: "text" },
    { name: "proveedor", label: "PROVEEDOR", description: "¿EL BIEN TIENE PROVEEDOR?", type: "text" },
    { name: "observaciones", label: "OBSERVACIONES", description: "¿EL BIEN TIENE OBSERVACIONES?", type: "text" },
];

  const [errors, setErrors] = React.useState({//* - ESTADO ERRORES
    partida: [], bien: [], edificio: [], area: [], costo: [], marca: [], modelo: [], noSerie: [],
    estadoFisico: [], noFactura: [], fechaAdquisicion: [], noPoliza: [], noInvAnterior: [],
    proveedor: [], descripcionFisica: [], observaciones: [], foto: [],
  });

  const [activeStep, setActiveStep] = React.useState(0); //* - ESTADO PARA CONTROLAR EL STEPPER
  const [preview, setPreview] = React.useState(null); //* - ESTADO PARA GUARDAR PREVIEW DE IMAGEN

  const apiInstance = React.useMemo( () => new ApiController(process.env.REACT_APP_API_URL), []); //! INSTANCIA DE API

  const getData = async () => await apiInstance.get("/inventory/constants");
  const getPropertiesByPartida = async (value) => await apiInstance.get(`/inventory/constants/property?partida=${value}`);
  const getAreasByBuilding = async (value) => await apiInstance.get(`/inventory/constants/area?building=${value}`);
  const CreateData = async (data) => await apiInstance.postFormData("/inventory", data);

  React.useEffect(() => {
    (async () => {
      setOpenBackdrop(true);
      const response = await getData();
      if (response.success) {
        setDataGet((prev) => ({
          ...prev,
          PARTIDA: response.data.PARTIDA || [],
          BUILDING: response.data.BUILDING || [],
          ESTADO_FISICO: response.data.ESTADO_FISICO || [],
        }));
      } else if (!response.success) {
        Swal.fire({
          title: "¡ERROR! ❌",
          icon: "error",
          text: "NO SE PUDIERON CARGAR LOS DATOS",
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor: "#ef7474",
          confirmButtonText: "CONFIRMAR",
          padding: "0 0 20px",
        });
        handleClose();
      }
      setOpenBackdrop(false);
    })();
  }, []);

React.useEffect(() => {//CENTRAR EL HEADER DEL STEPPER EN CADA PASO
  if (stepRefs.current[activeStep] && stepperRef.current) {
    const stepNode = stepRefs.current[activeStep];
    const stepperNode = stepperRef.current;
    const stepLeft = stepNode.offsetLeft;
    const stepWidth = stepNode.offsetWidth;
    const stepperWidth = stepperNode.offsetWidth;
    const scrollTo = stepLeft - stepperWidth / 2 + stepWidth / 2;
    stepperNode.scrollTo({
      left: scrollTo,
      behavior: "smooth",
    });
  }
}, [activeStep]);

  const validateFieldGeneric = (value, options = {}, switchState = true) => {//VALIDAR POR CAMPO UNITARIO
    const errors = [];
    if (options.required && switchState && !value) errors.push({ type: "required" });
    if (value && options.pattern && !options.pattern.test(value)) errors.push({ type: "invalid" });
    if (value && options.minLength && value.length < options.minLength) errors.push({ type: "minLength" });
    if (value && options.maxLength && value.length > options.maxLength) errors.push({ type: "maxLength" });
    return errors;
  };

  const validateAllFields = (fieldsToValidate) => {//RECORRER CADA VALIDACION
    const newErrors = {};
    for (const field of fieldsToValidate) {
      const isEnabled = controllSwitch[field] !== undefined ? controllSwitch[field] : true;
      newErrors[field] = validateFieldGeneric(
        data[field],
        PROPERTIES_ENTRIES[field],
        isEnabled
      );
    }
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return !Object.values(newErrors).some((fieldErrors) => fieldErrors.length > 0);
  };

  const getHelperText = (field) => {//AGREGAR MENSAJES DE ERROR
    return ( errors[field].map((e) => "- *" + ERROR_MESSAGES[e.type]).join("\n") || "");
  };

  const stepHasError = (step) => {//ERRORES EN EL STEPPER
    let fieldsToCheck = [];
    switch (step) {
      case 0: fieldsToCheck = ["partida"]; break;
      case 1: fieldsToCheck = ["bien"]; break;
      case 2: fieldsToCheck = ["edificio"]; break;
      case 3: fieldsToCheck = ["area"]; break;
      case 4: fieldsToCheck = ["costo", "marca", "modelo", "noSerie", "estadoFisico", "noFactura", "fechaAdquisicion",
                               "noPoliza", "noInvAnterior", "proveedor", "descripcionFisica", "observaciones",
                              ]; break;
      case 5: fieldsToCheck = ["foto"]; break; 
      default: fieldsToCheck = []; break;
    } return fieldsToCheck.some((field) => errors[field]?.length > 0);
  };

  const handleControllSwitch = (e) => {
  const { name, checked } = e.target;
    setControllSwitch((prev) => ({
      ...prev,
      [name]: checked,
    }));
    if (!checked) {
      setData((prev) => ({ ...prev, [name]: null }));
      setErrors((prev) => ({ ...prev, [name]: [] }));
    } else setData((prev) => ({ ...prev, [name]: "" }));
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value
    }));
    if (name === "partida") {
      setOpenBackdrop(true);
      setDataGet((prev) => ({ ...prev, PROPERTY: [] }));
      setData((prev) => ({ ...prev, bien: "" }));
      if (value) {
        const res = await getPropertiesByPartida(value);
        if (res.success) {
          setDataGet((prev) => ({
            ...prev,
            PROPERTY: res.data.PROPERTY || [],
          }));
        } else {
          setDataGet((prev) => ({ ...prev, PROPERTY: [] }));
        }
      }
      setOpenBackdrop(false);
    }
    if (name === "edificio") {
      setOpenBackdrop(true);
      setDataGet((prev) => ({ ...prev, AREA: [] }));
      setData((prev) => ({ ...prev, area: "" }));
      if (value) {
        const res = await getAreasByBuilding(value);
        if (res.success) {
          setDataGet((prev) => ({ ...prev, AREA: res.data.AREA || [] }));
        } else {
          setDataGet((prev) => ({ ...prev, AREA: [] }));
        }
      }
      setOpenBackdrop(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    let errorMessage = "";
    //VALIDAR TIPO DE FORMATO DE IMAGEN
    if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      errorMessage = "SOLO SE PERMITEN IMÁGENES JPEG, PNG O JPG.";
    }
    //VALIDAR TAMAÑO DE IMAGEN
    const sizeMB = file.size / (1024 * 1024);
    if (!errorMessage && sizeMB > 5) {
      errorMessage = "EL ARCHIVO NO PUEDE SUPERAR LOS 5MB.";
    }
    //MOSTRAR ERRORES DE FORMATO DE IMAGEN
    setErrors((prev) => ({
      ...prev,
      foto: errorMessage ? [{ type: "invalid", message: errorMessage }] : [],
    }));

    if (!errorMessage) {//GUARDAR IMAGEN
      setData((prev) => ({ ...prev, foto: file }));
      //CREAR PREVIEW
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {//LIMPIAR PREVIEW Y DATA
      setPreview(null);
      setData((prev) => ({ ...prev, foto: "" }));
    }
  };

  const handleNext = () => {
    let fieldsToValidate = []; //VALIDAR SOLO ESAS ENTRADAS
    switch (activeStep) {
      case 0: fieldsToValidate = ["partida"]; break;
      case 1: fieldsToValidate = ["bien"]; break;
      case 2: fieldsToValidate = ["edificio"]; break;
      case 3: fieldsToValidate = ["area"]; break;
      case 4: fieldsToValidate = ["costo",
                                  "marca",
                                  "modelo",
                                  "noSerie",
                                  "estadoFisico",
                                  "noFactura",
                                  "fechaAdquisicion",
                                  "noPoliza",
                                  "noInvAnterior",
                                  "proveedor",
                                  "descripcionFisica",
                                  "observaciones",
                                  ]; break;
      case 5: fieldsToValidate = ["foto"]; break;
      default: fieldsToValidate = []; break;
    } if (!validateAllFields(fieldsToValidate)) return;//SI HAY ERRORES NO AVANZA
    setActiveStep((prev) => prev + 1);//AVANZAR AL SIGUIENTE PASO
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);//REGRESAR AL PASO ANTERIOR

  const handleReset = () => {
    setActiveStep(0);
    setData({
      partida: "", bien: "", edificio: "", area: "", costo: null,
      marca: "", modelo: "", noSerie: "", estadoFisico: null, noFactura: "",
      fechaAdquisicion: null, noPoliza: "", noInvAnterior: "", proveedor: "",
      descripcionFisica: "", observaciones: "", foto: ""
    });
    setErrors({
      partida: [], bien: [], edificio: [], area: [], costo: [],
      marca: [], modelo: [], noSerie: [], estadoFisico: [], noFactura: [],
      fechaAdquisicion: [], noPoliza: [], noInvAnterior: [], proveedor: [],
      descripcionFisica: [], observaciones: [], foto: [],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const invalidFields = Object.keys(PROPERTIES_ENTRIES).filter(
      (field) => !validateAllFields(field)
    );

    if (invalidFields.length > 0) {
      setActiveStep(0);
      return;
    }

    Swal.fire({
      title: "AGREGAR BIEN AL INVENTARIO ⚠️",
      text: "¿ESTAS SEGURO DE AGREGAR ESTE NUEVO BIEN?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, AGREGAR",
      confirmButtonColor: "#397e32",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setOpenBackdrop(true);
        const formData = new FormData(); //FORMDATA PARA ENVIO

        for (const key in data) {
          if (key === "foto") {
            if (data.foto instanceof File) formData.append("foto", data.foto);
          } else if (["costo", 
                      "marca",
                      "modelo", 
                      "noSerie", 
                      "noFactura", 
                      "fechaAdquisicion", 
                      "noPoliza", 
                      "noInvAnterior", 
                      "proveedor", 
                      "observaciones"].includes(key) && data[key] === null) formData.append(key, 'null');
            else if (data[key] !== null && data[key] !== undefined) formData.append(key, data[key]);
        }
        const res = await CreateData(formData);//CUERPO DE LA CARGA UTIL
        if (res.success) {
          Swal.mixin({
            toast: true,
            position: "bottom-start",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          }).fire({
            icon: "success",
            title: "BIEN AGREGADO AL INVENTARIO",
            text: "SE AGREGO CORRECTAMENTE",
          });
          if (refreshArea) refreshArea();
        } else if (!res.success && res.meta.conflictDuplicate) {
          Swal.fire({
            title: "DATOS DUPLICADOS ⚠️",
            icon: "info",
            html: `<p>ESTOS CAMPOS YA SE ENCUENTRAN REGISTRADOS DENTRO DE LA BASE DE DATOS:</p>
                      ${res.meta.fields.map((f) => `<li>${f}</li>`).join("")}`,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#ef7474",
            confirmButtonText: "CONFIRMAR",
            padding: "0 0 20px",
          });
        } else {
          Swal.fire({
            title: "¡ERROR! ❌",
            icon: "error",
            text: "NO SE PUDO AGREGAR ESTE BIEN AL INVENTARIO",
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#ef7474",
            confirmButtonText: "CONFIRMAR",
            padding: "0 0 20px",
          });
        }
        setOpenBackdrop(false);
        handleClose();
      }
    });
  };

  const renderStepContent = (step) => {//RENDER DE CADA PASO
    switch (step) {
      case 0:
        return (
          <Autocomplete
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
            disablePortal
            options={dataGet.PARTIDA}
            getOptionLabel={(option) => option.NOMBRE}
            value={dataGet.PARTIDA.find((dt) => dt.VALUE === data.partida) || null}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "partida",
                  value: newValue ? newValue.VALUE : "",
                },
              });
            }}
            noOptionsText="NO HAY PARTIDAS DISPONIBLES"
            sx={{ mt: 1, width: "300px" }}
            slotProps={{
              popper: {
                disablePortal: false,
                modifiers: [
                  {
                    name: "zIndex",
                    enabled: true,
                    phase: "write",
                    fn: ({ state }) => {
                      state.styles.popper.zIndex = 1300;
                    },
                  },
                ],
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="SELECCIONA LA PARTIDA"
                variant="outlined"
                fullWidth
                error={errors.partida.length > 0}
                helperText={
                  errors.partida.length > 0 ? getHelperText("partida") : ""
                }
                sx={{ "& .MuiFormHelperText-root": { whiteSpace: "pre-line" } }}
              />
            )}
          />
        );
      case 1:
        return (
          <Autocomplete
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          options={dataGet.PROPERTY}
          getOptionLabel={(option) => option.NOMBRE}
          value={dataGet.PROPERTY.find((dt) => dt.VALUE === data.bien) || null}
          onChange={(event, newValue) => {
            handleChange({
              target: {
                name: "bien",
                value: newValue ? newValue.VALUE : "",
              },
            });
          }}
          noOptionsText="NO HAY BIENES DISPONIBLES"
          sx={{ mt: 1, width: "300px" }}
          slotProps={{
            popper: {
              disablePortal: false,
              modifiers: [
                {
                  name: "zIndex",
                  enabled: true,
                  phase: "write",
                  fn: ({ state }) => {
                    state.styles.popper.zIndex = 1300;
                  },
                },
              ],
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="SELECCIONA EL BIEN"
              variant="outlined"
              fullWidth
              error={errors.bien.length > 0}
              helperText={errors.bien.length > 0 ? getHelperText("bien") : ""}
              sx={{ "& .MuiFormHelperText-root": { whiteSpace: "pre-line" } }}
            />
          )}
        />

        );
      case 2:
        return (
          <Autocomplete
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          options={dataGet.BUILDING}
          getOptionLabel={(option) => option.NOMBRE}
          value={dataGet.BUILDING.find((dt) => dt.VALUE === data.edificio) || null}
          onChange={(event, newValue) => {
            handleChange({
              target: {
                name: "edificio",
                value: newValue ? newValue.VALUE : "",
              },
            });
          }}
          noOptionsText="NO HAY EDIFICIOS DISPONIBLES"
          sx={{ mt: 1, width: "300px" }}
          slotProps={{
            popper: {
              disablePortal: false,
              modifiers: [
                {
                  name: "zIndex",
                  enabled: true,
                  phase: "write",
                  fn: ({ state }) => {
                    state.styles.popper.zIndex = 1300;
                  },
                },
              ],
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="SELECCIONA EL EDIFICIO"
              variant="outlined"
              fullWidth
              error={errors.edificio.length > 0}
              helperText={errors.edificio.length > 0 ? getHelperText("edificio") : ""}
              sx={{ "& .MuiFormHelperText-root": { whiteSpace: "pre-line" } }}
            />
          )}
          />
        );
      case 3:
        return (
        <Autocomplete
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          options={dataGet.AREA}
          getOptionLabel={(option) => option.NOMBRE}
          value={dataGet.AREA.find((dt) => dt.VALUE === data.area) || null}
          onChange={(event, newValue) => {
            handleChange({
              target: {
                name: "area",
                value: newValue ? newValue.VALUE : "",
              },
            });
          }}
          noOptionsText="NO HAY ÁREAS DISPONIBLES"
          sx={{ mt: 1, width: "300px" }}
          slotProps={{
            popper: {
              disablePortal: false,
              modifiers: [
                {
                  name: "zIndex",
                  enabled: true,
                  phase: "write",
                  fn: ({ state }) => {
                    state.styles.popper.zIndex = 1300;
                  },
                },
              ],
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="SELECCIONA EL ÁREA"
              variant="outlined"
              fullWidth
              error={errors.area.length > 0}
              helperText={errors.area.length > 0 ? getHelperText("area") : ""}
              sx={{ "& .MuiFormHelperText-root": { whiteSpace: "pre-line" } }}
            />
          )}
        />
        );

      case 4:
        return (
          <>
<Box display="flex" flexDirection="column" gap={2}>
  {fields.map((field) =>{
    const isDate = field.type === "date";
  return (
    <Box
      key={field.name}
      display="flex"
      flexDirection="column"
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        p: 1.5,
        bgcolor: "background.paper",
      }}
    >

  <Box display="flex" alignItems="center" gap={1}>
  {/* NO */}
  <Typography
    variant="caption"
    fontWeight={!controllSwitch[field.name] ? "bold" : "normal"}
    color={!controllSwitch[field.name] ? "text.primary" : "text.disabled"}
  >
    NO
  </Typography>

  {/* SWITCH */}
  <Switch
    name={field.name}
    checked={controllSwitch[field.name]}
    onChange={handleControllSwitch}
    color="success"
    size="small"
  />

  {/* SI */}
  <Typography
    variant="caption"
    fontWeight={controllSwitch[field.name] ? "bold" : "normal"}
    color={controllSwitch[field.name] ? "success.main" : "text.disabled"}
  >
    SI
  </Typography>

  {/* DESCRIPCIÓN DEL CAMPO */}
  <Typography variant="caption" sx={{ ml: 1 }}>
    {field.description}
  </Typography>
</Box>


      <TextField
        label={field.label}
        variant="outlined"
        autoComplete="off"
        fullWidth
        className={styles.textField_form}
        name={field.name}
        type={field.type || "text"} 
        value={controllSwitch[field.name] ? data[field.name] || "" : ""}
        onChange={handleChange}
        error={errors[field.name]?.length > 0}
        helperText={getHelperText(field.name)}
        sx={{ "& .MuiFormHelperText-root": { whiteSpace: "pre-line" } }}
        disabled={!controllSwitch[field.name]}
        {...(isDate && {
            InputLabelProps: { shrink: true },
            inputProps: { max: fechaHoy },
        })}
      />
    </Box>
  )})}
</Box>




            <TextField
              label="DESCRIPCIÓN FÍSICA"
              variant="outlined"
              multiline
              rows={3}
              autoComplete="off"
              fullWidth
              className={styles.textField_form}
              name="descripcionFisica"
              value={data.descripcionFisica}
              onChange={handleChange}
              error={errors.descripcionFisica.length > 0}
              helperText={getHelperText("descripcionFisica")}
              sx={{ "& .MuiFormHelperText-root": { whiteSpace: "pre-line" } }}
            />
            <FormControl
              variant="outlined"
              sx={{ mt: 1, mb: 1 }}
              fullWidth
              error={errors.estadoFisico.length > 0}
            >
              <InputLabel id="estado-label">ESTADO FISICO</InputLabel>
              <Select
                labelId="estado-label"
                id="estado-select"
                name="estadoFisico"
                value={data.estadoFisico}
                onChange={handleChange}
                label="ESTADO FISICO"
              >
                {Object.entries(dataGet.ESTADO_FISICO || {}).map(
                  ([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  )
                )}
              </Select>
              {errors.estadoFisico.length > 0 && (
                <FormHelperText sx={{ whiteSpace: "pre-line" }}>
                  {getHelperText("estadoFisico")}
                </FormHelperText>
              )}
            </FormControl>


          </>
        );
      case 5:
        return (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1">FOTO DEL BIEN</Typography>
            <Button
              variant="outlined"
              component="label"
              sx={{ mt: 1, mb: 1, width: "300px" }}
            >
              SELECCIONAR FOTO
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={handleFileChange}
              />
            </Button>
            {errors.foto.length > 0 && (
              <Typography
                variant="caption"
                color="error"
                display="block"
                sx={{ whiteSpace: "pre-line" }}
              >
                {errors.foto[0]?.message || getHelperText("foto")}
              </Typography>
            )}
            {preview && (
              <Box
                sx={{
                  mt: 1,
                  width: "300px",
                  height: "200px",
                  border: "2px dashed",
                  borderColor: errors.foto.length > 0 ? "#d23030" : "#1976d2",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "hidden",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <img
                  src={preview}
                  alt="preview"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              </Box>
            )}
          </Box>
        );
      default:
        return "Paso no encontrado";
    }
  };

  return (
    <>
      <CustomBackdrop open={openBackdrop} />
      <form className={styles.container_main_form} onSubmit={handleSubmit}>
      <Box
      ref={stepperRef}
      sx={{
        mt: 3,
        mb: 2,
        width: "100%",
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        sx={{ width: "100%" }}
      >
        {steps.map((label, index) => (
          <Step key={label} ref={(el) => (stepRefs.current[index] = el)}>
            <StepLabel error={stepHasError(index)}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
        <img src={imgAdd} alt="Logo" className={styles.logo_form} />
        <Typography variant="h7" gutterBottom align='center'>DAR DE ALTA UN NUEVO BIEN AL INVENTARIO</Typography>

        <div>
          {activeStep === steps.length ? (
            <Box textAlign="center">
              <Typography variant="subtittle1">
                ¡¡EL FORMULARIO ESTA LISTO PARA SER ENVIADO!!
              </Typography>
              <Button
                variant="contained"
                color="success"
                startIcon={<Queue />}
                type="submit"
                fullWidth
              >
                AGREGAR
              </Button>
              <Button onClick={handleReset} sx={{ ml: 2 }}>
                REINICIAR
              </Button>
            </Box>
          ) : (
            <Box>
              <Box mt={3} mb={2}>
                {renderStepContent(activeStep)}
              </Box>
              <Box display="flex" justifyContent="space-between">
                {activeStep !== 0 ? (
                  <Button onClick={handleBack}>ATRAS</Button>
                ) : (
                  <div /> //GUARDAR ESPACIO
                )}
                <Button
                  variant="contained"
                  color="success"
                  onClick={handleNext}
                  fullWidth
                  endIcon={
                    activeStep === steps.length - 1 ? (
                      <Done />
                    ) : (
                      <ArrowForward />
                    )
                  }
                >
                  {activeStep === steps.length - 1 ? "FINALIZAR" : "SIGUIENTE"}
                </Button>
              </Box>
            </Box>
          )}
        </div>
      </form>
    </>
  );
}